import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UsermanagementComponent } from './usermanagement/usermanagement.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSortModule} from '@angular/material/sort';
import { NgbPaginationModule, NgbAlertModule} from '@ng-bootstrap/ng-bootstrap';
import {​​​​​​​​ MatDatepickerModule }​​​​​​​​ from'@angular/material/datepicker';
import {​​​​​​​​ MatInputModule }​​​​​​​​ from'@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmDialogModule } from '@app/module/confirm-dialog/confirm-dialog.module';

@NgModule({
  declarations: [UsermanagementComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbPaginationModule,
    NgbAlertModule,
    NgbModule,ConfirmDialogModule,
    MatSortModule,MatDatepickerModule,MatInputModule,MatNativeDateModule
  ]
})
export class UsermanagementModule { }
